import React, { Component } from 'react';
import $ from "jquery"
import './Roadmap.css'


class Roadmap extends Component {
    render() {
        
        function checkViewPort() {
            var check;
            var top_of_element = $(".underline-level4").offset().top;
            var bottom_of_element = $(".underline-level4").offset().top + $(".underline-level4").outerHeight();
            var bottom_of_screen = $(window).scrollTop() + $(window).innerHeight();
            var top_of_screen = $(window).scrollTop();
        
            if ((bottom_of_screen > top_of_element) && (top_of_screen < bottom_of_element)){
                check=true;
            } else {
                check=false;
            }
            return check;
        }
    
        $(function () {
            var element = $(".underline-level4");
            $(window).on('scroll', function () {
                if(checkViewPort()) {
                    element.addClass("animateMe");
                }
            });
        });

        return (
            <div>
                <div className='mx-3 text-center'>
                    <div className='underline-level4'></div>
                    <h1 className="text-mint lato-light">Roadmap</h1>
                    {/* <p className='py-3'>An year long roadmap<br />⦿ Minting starts on 1 oct<br /> ⦿ Donating towards wildlife animal. Zoo is not the place for animals<br /> ⦿ Supporting Artists to start NFT journey. Helping them provide onboarding</p> */}

                    <div>
                        <div class="rightbox">
                            <div class="rb-container">
                                <ul class="rb">
                                    <li class="rb-item" ng-repeat="itembx">
                                        <div class="timestamp">
                                            10% Sale
                                        </div>
                                        <div class="item-title">Lucas McAlister just send you a message.</div>

                                    </li>

                                    <li class="rb-item" ng-repeat="itembx">
                                        <div class="timestamp">
                                            25% Sale
                                        </div>
                                        <div class="item-title">Chris Serrano posted a photo on your wall.</div>

                                    </li>
                                    <li class="rb-item" ng-repeat="itembx">
                                        <div class="timestamp">
                                            50% Sale
                                        </div>
                                        <div class="item-title">Mia Redwood commented on your last post.</div>

                                    </li>

                                    <li class="rb-item" ng-repeat="itembx">
                                        <div class="timestamp">
                                            75% Sale
                                        </div>
                                        <div class="item-title">Lucas McAlister just send you a message.</div>

                                    </li>

                                    <li class="rb-item" ng-repeat="itembx">
                                        <div class="timestamp">
                                            100% Sale
                                        </div>
                                        <div class="item-title">Lucas McAlister just send you a message.</div>

                                    </li>

                                </ul>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        );
    }
}

export default Roadmap;
